/**
 * Clone Legal Case
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const CLONE_TO = {
  globalTeamsOnly: false,
  legalCaseCheck: null,
  records: [],
  teamIds: [],
}

export const CloneLegalCaseState = {
  cloneLegalCase: {
    cloneTo: { ...CLONE_TO },
    currentStep: 'selectRecordStep',
    legalCaseId: null,
    legalCaseName: null,
    legalCaseRecords: [],
    duplicateLegalCaseToRecord: true,
  },
}

export const CloneLegalCaseActions = {
  cloneable: async (_, requestData) => {
    return axiosRequest.
      post(`/legal_cases/${requestData.id}/cloneable`, {
        legal_case: {
          record_ids: requestData.recordIds,
          team_ids: requestData.teamIds,
        },
      }).
      then(({ data }) => data).
      catch(handleError)
  },

  cloneLegalCaseToRecord: async (_, requestData) => {
    return axiosRequest.
      post(`/legal_cases/${requestData.id}/clone`, {
        legal_case: {
          record_ids: requestData.recordIds,
          team_ids: requestData.teamIds,
        },
      }).
      then(({ data }) => data).
      catch(handleError)
  },

  getLegalCaseRecords: async ({ commit }, requestData) => {
    commit('setSearchLoading', true)

    return axiosRequest.
      get('/records', { params: requestData.params }).
      then(({ data }) => {
        commit('setLegalCaseId', requestData.id)
        commit('setLegalCaseRecords', data.records || {})
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },

  resetCloneLegalCase: ({ commit }, _) => {
    commit('setCloneTo', { ...CLONE_TO })
  },

  setCloneLegalCaseToRecord: ({ commit }, value) => {
    commit('setCloneLegalCaseToRecord', value)
  },

  setCloneTo: ({ commit }, value) => {
    commit('setCloneTo', value)
  },

  setDuplicateLegalCaseToRecord: ({ commit }, value) => {
    commit('setDuplicateLegalCaseToRecord', value)
  },

  setPaginationOptions: ({ commit }, value) => {
    commit('setPaginationOptions', value)
  },

  setStep: ({ commit }, value) => {
    commit('setCurrentStep', value)
  },
}

export const CloneLegalCaseMutations = {
  setCloneTo: (state, payload) => {
    state.cloneLegalCase.cloneTo = payload
  },

  setCloneLegalCaseToRecord: (state, payload) => {
    state.cloneLegalCase.legalCaseId = payload.legalCaseId
    state.cloneLegalCase.legalCaseName = payload.legalCaseName
  },

  setCurrentStep: (state, payload) => {
    state.cloneLegalCase.currentStep = payload
  },

  setDuplicateLegalCaseToRecord: (state, payload) => {
    state.cloneLegalCase.duplicateLegalCaseToRecord = payload
  },

  setLegalCaseRecords: (state, payload) => {
    state.cloneLegalCase.legalCaseRecords = payload
  },
}

export const CloneLegalCaseGetters = {
  cloneTo: state => state.cloneLegalCase.cloneTo,
  currentStep: state => state.cloneLegalCase.currentStep,
  duplicateLegalCaseToRecord: state => state.cloneLegalCase.duplicateLegalCaseToRecord,
  legalCaseName: state => state.cloneLegalCase.legalCaseName,
  legalCaseTitle: state => `${state.cloneLegalCase.legalCaseName?.fullName} (Case ID: ${state.cloneLegalCase.legalCaseId})`,
  isLoading: state => state.isSearching,
  legalCaseId: state => state.cloneLegalCase.legalCaseId,
  legalCaseRecords: state => state.cloneLegalCase.legalCaseRecords,
  paginationOptions: state => state.paginationOptions,
}
